import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Package, RefreshCw, FileSpreadsheet } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const KurulumIndirmeleri = () => {
  const [kayitlar, setKayitlar] = useState([]);
  const [loading, setLoading] = useState(false);

  const yenile = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/app-dosyalari/kurulum/indirmeler`);
      setKayitlar(data);
    } catch (e) {
      toast.error('İndirme kayıtları alınamadı');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { yenile(); }, [yenile]);

  const excelIndir = async () => {
    try {
      const res = await axios.get(`${API}/app-dosyalari/kurulum/indirmeler/excel`, { responseType: 'blob' });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url; a.download = `kurulum_indirmeleri_${new Date().toISOString().slice(0, 10)}.xlsx`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error('Excel oluşturulamadı');
    }
  };

  return (
    <Card data-testid="kurulum-indirmeleri">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 flex-wrap">
          <Package className="w-5 h-5" /> Kurulum Dosyasını İndirenler
          <Badge variant="secondary">{kayitlar.length}</Badge>
          <div className="ml-auto flex gap-2">
            <Button variant="outline" size="sm" onClick={excelIndir} disabled={kayitlar.length === 0} data-testid="kurulum-indirmeleri-excel">
              <FileSpreadsheet className="w-4 h-4 mr-1" /> Excel
            </Button>
            <Button variant="outline" size="sm" onClick={yenile} disabled={loading} data-testid="kurulum-indirmeleri-yenile">
              <RefreshCw className={`w-4 h-4 mr-1 ${loading ? 'animate-spin' : ''}`} /> Yenile
            </Button>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {kayitlar.length === 0 ? (
          <p className="text-sm text-gray-500" data-testid="kurulum-indirme-yok">Henüz kimse kurulum dosyasını indirmedi.</p>
        ) : (
          <div className="max-h-80 overflow-y-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Ad Soyad / Unvan</TableHead>
                  <TableHead>Luca Üye No</TableHead>
                  <TableHead>E-posta</TableHead>
                  <TableHead>Telefon</TableHead>
                  <TableHead>Tarih</TableHead>
                  <TableHead>Durum</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {kayitlar.map((k, i) => (
                  <TableRow key={k.id} data-testid={`kurulum-indirme-${i}`}>
                    <TableCell className="font-medium">{k.ad_soyad || '—'}</TableCell>
                    <TableCell>{k.luca_uye_no}</TableCell>
                    <TableCell className="text-sm">{k.email || '—'}</TableCell>
                    <TableCell className="text-sm">{k.telefon || '—'}</TableCell>
                    <TableCell className="text-sm whitespace-nowrap">{new Date(k.created_at).toLocaleString('tr-TR')}</TableCell>
                    <TableCell>
                      {k.indirildi
                        ? <Badge className="bg-green-600">İndirildi</Badge>
                        : <Badge variant="outline">Başlatılmadı</Badge>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
